/* Shared functional Quick View + accessible wishlist tools for Minha Kidz. */
(() => {
  'use strict';
  const $ = (q,root=document) => root.querySelector(q);
  const $$ = (q,root=document) => Array.from(root.querySelectorAll(q));
  const modal = $('[data-mk-qv-modal]');
  if (!modal) return;
  const title = $('[data-mk-qv-title]',modal);
  const price = $('[data-mk-qv-price]',modal);
  const description = $('[data-mk-qv-description]',modal);
  const image = $('[data-mk-qv-image]',modal);
  const thumbs = $('[data-mk-qv-thumbs]',modal);
  const select = $('[data-mk-qv-variant]',modal);
  const variantLabel = $('[data-mk-qv-variant-label]',modal);
  const form = $('[data-mk-qv-form]',modal);
  const add = $('[data-mk-qv-add]',modal);
  const link = $('[data-mk-qv-link]',modal);
  const message = $('[data-mk-qv-message]',modal);
  const colorPills = $('[data-mk-qv-color-options]',modal);
  let lastFocus=null, activeProduct=null, requestNumber=0;

  const formatPrice = cents => {
    const currency=(document.body.dataset.currency||'PKR').toUpperCase();
    try { return new Intl.NumberFormat(document.documentElement.lang||'en-PK', {style:'currency',currency,maximumFractionDigits:2}).format(Number(cents||0)/100); }
    catch (_) {return 'Rs. '+(Number(cents||0)/100).toFixed(2)}
  };
  function closeModal(){
    if(modal.hidden) return;
    requestNumber++;
    modal.hidden=true;
    document.body.classList.remove('mk-qv-open');
    lastFocus?.focus?.({preventScroll:true});
  }
  function setImage(url, alt){
    if(!url){image.removeAttribute('src');image.alt='No product photo';return;}
    image.src=url.startsWith('//')?`https:${url}`:url;
    image.alt=alt||'';
  }
  function updateWishlistLabels(){
    $$('[data-chd-wishlist-add]').forEach(b=>{
      const saved=b.classList.contains('is-saved');
      b.setAttribute('aria-pressed',String(saved));
      const name=b.dataset.name||'product';
      b.setAttribute('aria-label',`${saved?'Remove':'Save'} ${name} ${saved?'from':'to'} wishlist`);
      b.title=saved?'Remove from wishlist':'Save to wishlist';
    });
  }
  function selectVariant(){
    const variant=activeProduct?.variants?.find(v=>String(v.id)===select.value);
    if(!variant){add.disabled=true;return}
    price.textContent=formatPrice(variant.price);
    const available=Boolean(variant.available);
    add.disabled=!available;
    add.textContent=available?'Add to bag ↗':'Sold out';
    message.textContent='';
    if(variant.featured_image?.src){setImage(variant.featured_image.src,activeProduct.title+' — '+variant.title)}
    if(colorPills){
      $$('button',colorPills).forEach(b=>{
        const n=Number(b.dataset.colorIndex);
        const active=(variant.options?.[n]||variant['option'+(n+1)])===b.dataset.colorValue;
        b.setAttribute('aria-pressed',String(active));
      });
    }
  }
  function renderProduct(product){
    activeProduct=product;
    title.textContent=product.title || 'Product';
    link.href=product.url || link.href;
    const doc=new DOMParser().parseFromString(product.description||product.body_html||'', 'text/html');
    const plain=(doc.body.textContent||'').replace(/\s+/g,' ').trim();
    description.textContent=plain.length>210?plain.slice(0,210).trimEnd()+'…':plain;
    description.hidden=!plain;
    const images=(product.images||[]).filter(Boolean).slice(0,8);
    thumbs.replaceChildren();
    setImage(images[0]||product.featured_image,product.title);
    images.forEach((url,index)=>{
      const b=document.createElement('button');b.type='button';b.className='mk-qv-thumb';
      b.setAttribute('aria-label',`View image ${index+1}`);
      b.setAttribute('aria-current',String(index===0));
      const i=document.createElement('img');i.src=url.startsWith('//')?`https:${url}`:url;
      i.alt='';i.loading='lazy';b.append(i);
      b.addEventListener('click',()=>{
        setImage(url,product.title);
        $$('[aria-current]',thumbs).forEach(x=>x.setAttribute('aria-current',String(x===b)));
      });
      thumbs.append(b);
    });
    select.replaceChildren();
    const variants=product.variants||[];
    variants.forEach(v=>{
      const opt=document.createElement('option');opt.value=String(v.id);
      opt.textContent=v.title+(v.available?'':' — Sold out');
      opt.disabled=!v.available;
      select.append(opt);
    });
    const showVariants=variants.length>1 || (variants[0] && variants[0].title!=='Default Title');
    select.hidden=!showVariants;
    variantLabel.hidden=!showVariants;
    const available=variants.find(v=>v.available);
    if(available) select.value=String(available.id);
    if(!available && variants.length) select.value=String(variants[0].id);
    if(colorPills){
      colorPills.replaceChildren();
      const names=(product.options||[]).map(o=>(typeof o==='string'?o:o.name||'').toLowerCase());
      const index=names.findIndex(n=>n.includes('color')||n.includes('colour')||n.includes('shade'));
      const colorMap={black:'#252525',white:'#fff',pink:'#f6b5c9','baby pink':'#f8d3dc',blue:'#79b7ed','baby blue':'#b7d9ee','sky blue':'#89c6e5',navy:'#203658',red:'#c54d4b',green:'#78a188',sage:'#aeb9a6',mint:'#bcdacf',yellow:'#efd071',orange:'#eaa071',brown:'#9b6b4c',beige:'#e7d2b3',cream:'#fbedd9',purple:'#a799cc',lavender:'#b8a9dc',grey:'#b7b8b8',gray:'#b7b8b8'};
      const seen=new Set();
      if(index>=0){variants.forEach(v=>{
        const val=v.options?.[index]||v['option'+(index+1)]||'';
        if(!val||seen.has(val))return;seen.add(val);
        const first=variants.find(x=>(x.options?.[index]||x['option'+(index+1)])===val&&x.available)||v;
        const button=document.createElement('button');button.type='button';button.className='mk-qv-color-pill';
        button.dataset.variantId=String(first.id);button.dataset.colorValue=val;button.dataset.colorIndex=String(index);
        button.setAttribute('aria-pressed',String(select.value===String(first.id)));
        button.setAttribute('aria-label','Choose color '+val);
        const dot=document.createElement('span');dot.className='mk-color-dot';dot.style.setProperty('--mk-dot',colorMap[val.toLowerCase()]||'#e7e5e0');
        const name=document.createElement('span');name.textContent=val;button.append(dot,name);
        button.addEventListener('click',()=>{select.value=button.dataset.variantId;select.dispatchEvent(new Event('change',{bubbles:true}))});
        colorPills.append(button);
      })}
      colorPills.hidden=seen.size<2;
    }
    selectVariant();
  }
  async function openModal(trigger){
    lastFocus=trigger;
    activeProduct=null;
    const req=++requestNumber;
    title.textContent=trigger.dataset.productName||'Loading product…';
    price.textContent='';description.textContent='';description.hidden=true;
    message.textContent='';add.disabled=true;add.textContent='Loading…';
    select.replaceChildren();thumbs.replaceChildren();setImage('', '');
    modal.hidden=false;
    document.body.classList.add('mk-qv-open');
    $('.mk-qv-close',modal)?.focus({preventScroll:true});
    try{
      // Native Shopify storefront product endpoint: /products/<handle>.js, works on any theme.
      const url=new URL(trigger.dataset.productUrl,window.location.origin);
      if(url.origin!==window.location.origin)throw Error('Invalid product link');
      const api=new URL(url);
      api.search=''; api.hash=''; api.pathname=api.pathname.replace(/\/$/,'')+'.js';
      const response=await fetch(api.toString(),{headers:{'Accept':'application/json'}});
      if(!response.ok)throw Error('Unable to load product');
      const product=await response.json();
      if(req!==requestNumber || modal.hidden)return;
      product.url=url.pathname;
      renderProduct(product);
    }catch(e){
      if(req!==requestNumber)return;
      title.textContent='View product details';
      message.textContent='Preview could not load. Open the full product page instead.';
      link.href=trigger.dataset.productUrl;
      add.disabled=true;add.textContent='Unavailable';
    }
  }
  select.addEventListener('change',selectVariant);
  document.addEventListener('click',event=>{
    const trigger=event.target.closest('[data-mk-quick-view]');
    if(trigger){event.preventDefault();openModal(trigger);return;}
    if(event.target.closest('[data-mk-qv-close]')){event.preventDefault();closeModal();return;}
    if(event.target.closest('[data-chd-wishlist-add]')){
      // The original theme owns wishlist storage/drawer logic; reflect that state accessibly.
      updateWishlistLabels();
    }
  });
  document.addEventListener('keydown',event=>{
    if(modal.hidden)return;
    if(event.key==='Escape'){event.preventDefault();event.stopPropagation();closeModal();return;}
    if(event.key==='Tab'){
      const focusables=$$('a[href],button:not([disabled]),select:not([disabled]),input:not([disabled])',modal)
        .filter(el=>!el.hidden && el.getClientRects().length>0);
      if(!focusables.length)return;
      const first=focusables[0],last=focusables[focusables.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    }
  },true);
  form.addEventListener('submit',async e=>{
    e.preventDefault();
    if(!activeProduct||add.disabled)return;
    const old=add.textContent;
    add.disabled=true;add.textContent='Adding…';message.textContent='';
    try{
      const payload=new FormData(form);
      const response=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:payload});
      if(!response.ok){const err=await response.json().catch(()=>({}));throw new Error(err.description||'Unable to add to cart')}
      closeModal();
      // Reuse existing Minha Kidz cart drawer so totals/count refresh correctly.
      const cartTrigger=$('[data-cart-open]');
      if(cartTrigger)cartTrigger.click();
      else window.location.assign('/cart');
    }catch(err){message.textContent=err.message||'Could not add the item. Please try again.'}
    finally{add.textContent=old;selectVariant()}
  });
  document.addEventListener('shopify:section:load',updateWishlistLabels);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',updateWishlistLabels);
  else updateWishlistLabels();
})();
